/*********************** Custom JS for Boost AI Search & Discovery  ************************/
// Function to update tabindex and aria-hidden for focusable elements within .slick-slide on RCM
function updateSlickSlideFocusableElements() {
    console.log('123');
    // Select all slick-slide elements
    const slickSlides = document.querySelectorAll('.boost-sd__recommendation .slick-slide');

    slickSlides.forEach(slide => {
        // Check if the slide is hidden
        const isHidden = slide.getAttribute('aria-hidden') === "true";
        console.log('isHidden');
        // Find all focusable elements within the slide
        const focusableElements = slide.querySelectorAll('a, button, input, select, textarea, [tabindex]');
        
        focusableElements.forEach(element => {
            console.log('element: ', element)
            // If the slide is hidden, disable focus; otherwise, restore default focus behavior
            if (isHidden) {
                // Set tabindex to -1 to disable focus
                element.tabIndex = -1;
            } else {
                // Remove tabindex attribute so it returns to the default focusable state
                element.removeAttribute('tabindex');
            }
        });
    });
}

const slugify = (text) => {
	if (text == null || typeof text == 'object') return '';
	if (typeof text != 'string') {
		if (typeof text.toString != 'function') {
			return '';
		} else {
			text = text.toString();
		}
	}
	text = text.toLowerCase();

	// Remove Latin
	var from = "àáäâãèéëêẽìíïîĩòóöôõùúüûũñç·/_,:;";
	var to = "aaaaaeeeeeiiiiiooooouuuuunc--_---";
	for (var i = 0, l = from.length; i < l; i++)
		text = text.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));

	// Remove Czech, Finnish special characters
	var specialCzechChars = 'ÁáÄäČčĎďÉéěÍíŇňÓóÖöŘřŠšŤťÚúůÝýŽž';
	var asciiCzechChars = 'AaAaCcDdEeeIiNnOoOoRrSsTtUuuYyZz';
	var specialCzechCharsLength = specialCzechChars.length;
	for (var j = 0; j < specialCzechCharsLength; j++) {
		text = text.replace(new RegExp(specialCzechChars.charAt(j), "g"), asciiCzechChars.charAt(j));
	}

	// Remove Norway special characters
	var specialNorwayChars = 'ÆæØøÅå';
	var asciiNorwayChars = ['AE', 'ae', 'O', 'o', 'A', 'a'];
	var specialNorwayCharsLength = specialNorwayChars.length;
	for (var k = 0; k < specialNorwayCharsLength; k++) {
		text = text.replace(new RegExp(specialNorwayChars.charAt(k), "g"), asciiNorwayChars[k]);
	}

	// Remove quotes
	text = text.replace(/'/g, '').replace(/"/g, '');

	return text.replace(/[\s\/]+/g, '-')    // Replace spaces with -
		.replace(/[`~!@#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '-')   // Replace all special characters with -
		.replace(/\-\-+/g, '-')     // Replace multiple - with single -
		.replace(/^-+/, '')         // Trim - from start of text
		.replace(/-+$/, '');         // Trim - from end of text
};

function available_zones(data) {
    var tags = data.tags;
    let newtags = [];

    let zonetags = tags.filter(function(tag) {
        return tag.includes("filter::zone");
    });

    let filteredtags = zonetags.map(function(tag) {
        return JSON.stringify(tag.replace("filter::zone||", ""));
    });

    for (let x = 0; x < filteredtags.length; x++) {
        newtags.push(filteredtags[x].replace(/"/g, '\''));
    }

    return newtags
}

function buildBadge(data) {
    var html = "";
    var featured_values = ["promo", "new", "best-seller", "sale"];
    var zone_values = [
        "2-5",
        "2-6",
        "2-7",
        "2-8",
        "2-9",
        "3-4",
        "3-5",
        "3-6",
        "3-7",
        "3-8",
        "3-9",
        "3-10",
        "4-5",
        "4-6",
        "4-7",
        "4-8",
        "4-9",
        "4-10",
        "4-11",
        "5-6",
        "5-7",
        "5-8",
        "5-9",
        "5-10",
        "5-11",
        "6-7",
        "6-8",
        "6-9",
        "6-10",
        "7-8",
        "7-9",
        "7-10",
        "7-11",
        "8-9",
        "8-10",
        "8-11",
        "9-10",
        "9-11",
        "10-11 ",
    ];
    var light_values = [
        "part sun/sun/shade",
        "part shade/shade",
        "part sun/shade",
        "part sun",
        "part sun/sun",
        "sun",
        "shade",
        "sun/shade",
    ];
    var badges = data.tags
        .filter(function(tag) {
            return tag.indexOf("badge") > -1 && tag.indexOf("::") > -1;
        })
        .map(function(badge) {
            return badge.replace("badge", "").replace("::", "");
        });
    var featured_badge = badges.find(function(badge) {
        return featured_values.indexOf(badge) > -1;
    });
    var zone_badge = badges.find(function(badge) {
        return zone_values.indexOf(badge) > -1;
    });
    var light_badge = badges.find(function(badge) {
        return light_values.indexOf(badge) > -1;
    });

    if (featured_badge) {
        html += '<div class="ProductTile__badge"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#product-badge-' +
                    featured_badge +
                '"></use></svg></div>';
    }

    if (zone_badge && featured_badge) {
        html += '<div class="ProductTile__badge ProductTile__badge--zone ProductTile__badge--nudge"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#' +
                    zone_badge +
                '" /></svg></div>';
    } else if (zone_badge) {
        html += '<div class="ProductTile__badge ProductTile__badge--zone "><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#' +
                    zone_badge +
                '" /></svg></div>';
    }

    if (light_badge && featured_badge) {
        html += '<div class="ProductTile__badge ProductTile__badge--light ProductTile__badge--nudge"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#product-badge-' +
                    slugify(light_badge) +
                '" /></svg></div>';
    } else if (light_badge) {
        html += '<div class="ProductTile__badge ProductTile__badge--light"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#product-badge-' +
                    slugify(light_badge) +
                '" /></svg></div>';
    }

    return html;
}

const customize = {
    updateProductItemGrid: (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'Customize Product Item',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        // Start customization--------------------------------------------
                        let productData = element.getParams().props.product ||
                            element.getParams().props.productData ||
                            element.getParams().props.data;
                        let productItems = document.querySelectorAll('[data-product-id="' + productData.id + '"]');

                        // Build custom ATC
                        let prodtitle = productData.title;
                        let newtitle = prodtitle.replace(/'/g, '');
                        let html = '';

                        html += '<div class="boost-sd__ATC">';
                        if (productData.variants.length > 1) {
                            html += '<a href="' + Shopify?.routes?.root + '/products/' + productData.handle + '" class="Button Button--primary ProductTile__button focuselems">';
                            if (!productData.available) {
                                html += boostPFSAppConfig?.settings?.label?.action_list?.qvSoldOutLabel || 'Sold out';
                            } else {
                                html += boostPFSAppConfig?.settings?.label?.action_list?.qvViewFullDetails || 'View details';
                            }
                            html += '</a>';
                        } else {
                            html += '<button type="submit" name="add" class="ProductTile__button Button Button--primary focuselems" data-add-to-cart ' +
                                      'onclick="Neptune.cart.add({ id:' + productData.variants[0].id +
                                      ', quantity:1, properties:{ \'_growingzone\':[' + available_zones(productData) + ']} }, \'.atcprod-' + productData.variants[0].id  + '\', { quantity: 1, image: \'' + productData.images[1] + '\', title: \'' + newtitle + '\', option: \'' + productData.variants[0].option_size + '\' }); return false;"';
                            if (productData.variants[0].available === false) {
                                html += 'disabled="disabled">';
                            } else {
                                html += '>';
                            }
                            html += '<span class="atcprod-' + productData.variants[0].id + '" data-add-to-cart-text>';
                            if (productData.variants[0].available) {
                                html += boostPFSAppConfig?.settings?.label?.action_list?.qvAddToCartBtnLabel || 'Add to cart';
                            } else {
                                html += boostPFSAppConfig?.settings?.label?.action_list?.qvSoldOutLabel || 'Sold out';
                            }
                            html += '</span></button></form>';
                        }
                        html += '</div>';
                        
                        if (productItems.length > 0) {
                            for (let productItem of productItems) {
                                if (productItem.querySelector('.boost-sd__ATC') == null) {
                                    productItem.querySelector('.boost-sd__product-info').insertAdjacentHTML('beforeend', html);
                                }

                                if (productItem.querySelector('.boost-sd__product-image-column--right') && productItem.querySelector('.ProductTile__badge') == null) {
                                    productItem.querySelector('.boost-sd__product-image-column--right').insertAdjacentHTML('beforeend', buildBadge(productData));
                                }
                            }

                            updateSlickSlideFocusableElements();
                        }
                    } catch (e) {
                        console.error(e);
                    }
                }
            }),
        });
    }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItemGrid]);